import { Injectable } from '@angular/core';

import { MediaQueryService } from '@frontend/vanilla/core';
import { entries, max } from 'lodash-es';
import { Observable, map } from 'rxjs';

interface MediaQuery {
    min?: number;
    max?: number;
    columns: number;
}

@Injectable()
export class MyBetsListService {
    private widthBreakpoints: MediaQuery[] = [];

    private breakpoints = {
        'lt-mw': 1,
        'mw': 2,
        'gt-mw': 3,
    };

    constructor(private mediaService: MediaQueryService) {
        entries(this.mediaService.breakpoints)
            .filter((point) => this.breakpoints[point[0] as keyof typeof this.breakpoints])
            .forEach((point) =>
                this.widthBreakpoints.push({
                    columns: this.breakpoints[point[0] as keyof typeof this.breakpoints],
                }),
            );
    }

    asObservable(): Observable<number> {
        return this.mediaService.observe().pipe(map(() => this.columns));
    }

    get columns(): number {
        const fitting = Object.keys(this.breakpoints)
            .filter((k) => this.mediaService.isActive(k))
            .map((k) => this.breakpoints[k as keyof typeof this.breakpoints]);

        return max(fitting) || 1;
    }
}
